// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3I8Nf","info":"Note_info__Zg_bp","note":"Note_note__15xxD","actions":"Note_actions__2z6IA"};